import { render, staticRenderFns } from "./AddLensPlatformAccountButton.vue?vue&type=template&id=81b5b680&scoped=true"
import script from "./AddLensPlatformAccountButton.vue?vue&type=script&lang=js"
export * from "./AddLensPlatformAccountButton.vue?vue&type=script&lang=js"
import style0 from "./AddLensPlatformAccountButton.vue?vue&type=style&index=0&id=81b5b680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b5b680",
  null
  
)

export default component.exports